import { PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

type TextProps = React.HTMLAttributes<HTMLSpanElement>;

export const SemiBoldText = (
  props: PropsWithChildren<TextProps>
): JSX.Element => (
  <span {...props} className={cn(styles.semiBoldText, props.className)}>
    {props.children}
  </span>
);
